import useSearchSettings from 'hooks/useSearchSettings';
import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

const SearchPreferencesModal = ({ show, onHide, onUpdate }) => {
  const { searchSettings, isUpdating } = useSearchSettings();
  const [localSettings, setLocalSettings] = useState(searchSettings);

  // Atualizar configurações locais quando as configurações mudarem
  useEffect(() => {
    if (searchSettings) {
      setLocalSettings(searchSettings);
    }
  }, [searchSettings]);

  const handleToggle = field => {
    setLocalSettings(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const handleSave = async () => {
    let result;
    if (onUpdate) {
      result = await onUpdate(localSettings);
    } else {
      // Fallback para uso direto do hook
      const { updateSearchSettings } = useSearchSettings();
      result = await updateSearchSettings(localSettings);
    }

    if (result.success) {
      onHide();
    }
  };

  const handleCancel = () => {
    setLocalSettings(searchSettings);
    onHide();
  };

  if (!searchSettings) return null;

  return (
    <Modal show={show} onHide={handleCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Preferências de pesquisa</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-4">
          <h5 className="fw-bold mb-3">Tickets</h5>

          <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
            <span>Assunto</span>
            <Form.Check
              type="switch"
              checked={localSettings?.searchInSubject || false}
              onChange={() => handleToggle('searchInSubject')}
              className="ms-2"
            />
          </div>

          <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
            <span>Descrição</span>
            <Form.Check
              type="switch"
              checked={localSettings?.searchInDescription || false}
              onChange={() => handleToggle('searchInDescription')}
              className="ms-2"
            />
          </div>

          <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
            <span>Propriedades do ticket</span>
            <Form.Check
              type="switch"
              checked={localSettings?.searchInProperties || false}
              onChange={() => handleToggle('searchInProperties')}
              className="ms-2"
            />
          </div>

          <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
            <span>Notas e respostas</span>
            <Form.Check
              type="switch"
              checked={localSettings?.searchInNotes || false}
              onChange={() => handleToggle('searchInNotes')}
              className="ms-2"
            />
          </div>

          <div className="d-flex justify-content-between align-items-center py-2">
            <span>Anexos (nomes de arquivos)</span>
            <Form.Check
              type="switch"
              checked={localSettings?.searchInAttachments || false}
              onChange={() => handleToggle('searchInAttachments')}
              className="ms-2"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="falcon-default" onClick={handleCancel}>
          Cancelar
        </Button>
        <Button onClick={handleSave} disabled={isUpdating}>
          {isUpdating ? 'Salvando...' : 'Aplicar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SearchPreferencesModal;
